import { render } from "./Item8.0.vue?vue&type=template&id=f5530d66&scoped=true&ts=true"
import script from "./Item8.0.vue?vue&type=script&lang=ts"
export * from "./Item8.0.vue?vue&type=script&lang=ts"

import "./Item8.0.vue?vue&type=style&index=0&id=f5530d66&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5530d66"]])

export default __exports__